export default __webpack_public_path__ + "static/media/lb.2cb9da1e.svg";